import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";
import Login from "@/pages/Login";
import store from "@/store";
// import { api } from "../api";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/login"
    },
    {
      path: "/",
      redirect: "/leads"
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/leads/",
      name: "leads",
      component: () =>
        import(/* webpackChunkName: "leads" */ "../pages/Leads.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ":id",
          component: () => import("../pages/Leads_ID"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/contacts/",
      name: "Contacts",
      component: () =>
        import(/* webpackChunkName: "leads" */ "../pages/Contacts.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ":id",
          component: () => import("../pages/Leads_ID"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    // {
    //   path: "/leads/:id",
    //   name: "leads-details",
    //   component: () =>
    //     import(/* webpackChunkName: "leads" */ "../pages/Leads.vue"),
    //   props: true,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: "/sms",
      name: "sms",
      component: () => import("../pages/SMS.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ":campaignId",
          component: () => import("../pages/SMS_Campaign"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/edm",
      name: "edm",
      component: () => import("../pages/EDM.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/edm/campaign/:campaignId",
          component: () => import("../components/edm/EdmStatView"),
          meta: {
            requiresAuth: true
          }
        },
        {
          path: "/edm/group-mails/:groupMailId",
          component: () => import("../components/edm/GroupMailStatView"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/events",
      name: "events",
      component: () => import("../pages/Events.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: "/events/:eventId",
          component: () => import("../components/edm/EdmStatView"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/apts",
      name: "appointments",
      component: () => import("../pages/Appointments.vue"),
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: ":day",
          component: () => import("../pages/Appointments_Day"),
          meta: {
            requiresAuth: true
          }
        }
      ]
    },
    // {
    //   path: "/products",
    //   name: "products",
    //   component: () =>
    //     import(/* webpackChunkName: "products" */ "../pages/Products.vue"),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: "/email-templates",
      name: "emailTemplates",
      component: () => import("../pages/EmailTemplates.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/conf",
      name: "conf",
      component: () => import("../pages/Conf.vue"),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/tests",
      name: "tests",
      component: () => import("../pages/Tests.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // console.log("to", to);
  if (!store.state.app.firstPath) {
    store.commit("app/setFirstPath", to.path);
  }
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) {
    next("login");
  } else {
    next();
  }
});

export default router;
